export const getAvgFromNumbersArray = arr => {
    const arrSum = arr.reduce((acc, item) => acc + item, 0);
    return Math.round(arrSum/arr.length);
};
